import apiClient from '@/lib/apiClient';
import { ApiResponse } from '@/types';

// RM-added cities the server persists, grouped by state. Merged with the
// bundled india-states-cities.json to build the City dropdown options.
export type CitiesByState = Record<string, string[]>;

export interface CustomCityRow {
  id: number;
  state: string;
  city: string;
}

export const locationsService = {
  getCustomCities: async (): Promise<CitiesByState> => {
    const { data } = await apiClient.get<ApiResponse<CitiesByState>>('/custom-cities');
    return data.data ?? {};
  },

  addCustomCity: async (state: string, city: string): Promise<void> => {
    await apiClient.post('/custom-cities', { state, city });
  },

  // ─── Admin moderation ──────────────────────────────────────────────────────
  listAllCustomCities: async (): Promise<CustomCityRow[]> => {
    const { data } = await apiClient.get<ApiResponse<CustomCityRow[]>>('/admin/custom-cities');
    return data.data ?? [];
  },

  updateCustomCity: async (id: number, city: string): Promise<void> => {
    await apiClient.put(`/admin/custom-cities/${id}`, { city });
  },

  deleteCustomCity: async (id: number): Promise<void> => {
    await apiClient.delete(`/admin/custom-cities/${id}`);
  },
};
